import React, { useEffect, useContext, useRef } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Header from "./component/inc/Header";
import Home from "./component/pages/Home";
import About from "./component/pages/About";

import {
  Route,
  Routes,
  useLocation,
  Navigate,
  useNavigate,
} from "react-router-dom";
import Footer from "./component/inc/Footer";
import PatientSidebar from "./component/inc/PatientSidebar";
import ScrollToTop from "./component/inc/ScrollToTop";
import ContactUs from "./component/pages/ContactUs";
import FindTherapist from "./component/pages/FindTherapist";
import Patientregisteration from "./component/pages/patient/Patientregisteration";
import Login from "./component/pages/therapist/Login";
import Otp from "./component/pages/therapist/Otp";
import TherapistRegisteration from "./component/pages/therapist/TherapistRegisteration";
import TherapistCompleteProfile from "./component/pages/therapist/TherapistCompleteProfile";
import TherapistDetailsPage from "./component/pages/TherapistDetailsPage";
import BookAnAppointment from "./component/pages/BookAnAppointment";
import EnterPaymentDetails from "./component/pages/EnterPaymentDetails";
import PatientFavourite from "./component/pages/patient/PatientFavourite";
import PaymentSettings from "./component/pages/patient/PaymentSettings";
import PatientEditProfile from "./component/pages/patient/PatientEditProfile";
import Dashboard from "./component/pages/therapist/Dashboard";
import TherapistSidebar from "./component/inc/TherapistSidebar";
import DeleteAccountInstructions from "./component/pages/DeleteAccountInstructions";
import Chat from "./component/pages/therapist/Chat";
import NotificationSettings from "./component/pages/therapist/NotificationSettings";
import TherapistEditProfile from "./component/pages/therapist/TherapistEditProfile";
import TherapistEarnings from "./component/pages/therapist/TherapistEarnings";
import TherapistBankDetails from "./component/pages/therapist/TherapistBankDetails";
import TherapistBankConnected from "./component/pages/therapist/TherapistBankConnected";
import HelpAndSupport from "./component/pages/HelpAndSupport";
import PrivacyPolicy from "./component/pages/PrivacyPolicy";
import TermsOfService from "./component/pages/TermsOfService";
import MayRenderNav from "./component/inc/MayRenderNav";
import RatingreView from "./component/pages/RatingreView";
import AppointmentDetail from "./component/pages/AppointmentDetail";
import PatientAppointmentDetail from "./component/pages/patient/PatientAppointmentDetail";
import TherapistAppointmentDetail from "./component/pages/therapist/TherapistAppointmentDetail";
import RequestAppointmentDetails from "./component/pages/therapist/RequestAppointmentDetails";
import Hipaa from "./component/pages/Hipaa";
import QandA from "./component/pages/Q&A";
import Therapist from "./component/pages/Therapist";
import Loader from "./component/common/Loader";
import io from "socket.io-client";
import CallIcon from "@mui/icons-material/Call";
import VideoCallOutlinedIcon from "@mui/icons-material/VideoCallOutlined";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { ToastContainer, toast } from "react-toastify";
import { AuthContext } from "./utility/services/AuthContext";
import ConstConfig from "./utility/configs/constConfig";
import ApiService from "./utility/services/ApiService";
import Team from "./component/pages/Team";
import { ReactIdleProvider } from "./component/common/components/ReactIdle";
import ReactJsAlert from "reactjs-alert";
import News from "./component/pages/News";
import BlogPost from "./component/pages/BlogPost";
import Functions from "./utility/services/Functions";
import CustomAlertModal from "./component/common/components/CustomAlertModel";
import ChatBot from "./component/common/ChatBot";
import FloatingCallWindow from "./component/common/FloatingCallWindow";
import debugLog from "./utility/services/debugLog";
import { trackEvent } from "./utility/services/analyticsService";

function ScrollToTopMain() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const {
    loading,
    setAgoraMessage,
    setAgoraNewMessage,
    setSocket,
    socket,
    user,
    setAcceptThroughPopup,
    selectedChat_user,
    app_js_intialLoad,
    google_client_id,
    setSessionModalShow,
    sessionModal,
    receive_call_audio,
    pauseAudio,
    setShowTimezoneChangeAlert,
    showTimezoneChangeAlert,
    setRefreshAppointmentType,
    showOldLicenseModal,
    setShowOldLicenseModal,
    isInCall,
    setIsInCall,
    authLoading,
    isCallMinimized,
    setIsCallMinimized,
    channelParameters,
    selectedUser,
    callMetadata,
    setCallMetadata,
    endCallFunctionRef,
    minimizeFunctionRef,

    // NEW: Unified call state
    unifiedCallState,
    updateCallState,
  } = useContext(AuthContext);
  const { setRunningCallId } = Functions();

  const isToken = user.access_token;
  const userDetails = user.details;
  const isDataFound = isToken != null;
  const { ROOT_PATH } = ConstConfig;
  const navigate = useNavigate();
  const location = useLocation();
  const { get_agora_token } = ApiService();

  // Picture-in-Picture Handlers
  const handleExpandFromFloating = () => {
    const currentPath = window.location.pathname;
    const locationPath = location.pathname;

    debugLog("App_ExpandFromFloating_Started", {
      windowPath: currentPath,
      reactRouterPath: locationPath,
      href: window.location.href,
      isOnChatPage: locationPath === "/chat",
      hasExpandRef: !!endCallFunctionRef.current?.expandFromPip,
      isCallMinimized,
      isInCall,
      callMetadata: {
        callType: callMetadata.callType,
        sendingCall: callMetadata.sendingCall,
        receivingCall: callMetadata.receivingCall,
        userName: callMetadata.userName,
      },
      unifiedCallState: {
        status: unifiedCallState.status,
        type: unifiedCallState.type,
        role: unifiedCallState.role,
        chat_id: unifiedCallState.chat_id,
      },
    });

    // Check if we're already on the /chat page
    // IMPORTANT: Use currentPath (window.location) not locationPath (React Router can be stale)
    if (currentPath === "/chat") {
      // Already on chat page - just expand without navigation
      debugLog("App_ExpandFromFloating_OnChatPage", {
        action: "calling expandFromPip or setting state",
      });

      if (endCallFunctionRef.current?.expandFromPip) {
        endCallFunctionRef.current.expandFromPip();
      } else {
        debugLog.warn(
          "App_ExpandFromFloating",
          "expandFromPip ref not available, using fallback"
        );
        updateCallState({ isMinimized: false });
        setIsCallMinimized(false);
      }
    } else {
      // On different page - navigate to /chat first
      debugLog("App_ExpandFromFloating_NavigatingToChat", {
        fromPath: location.pathname,
        toPath: "/chat",
        navigateState: {
          chat_id: unifiedCallState.chat_id,
          expandingFromPip: true,
        },
      });

      // DON'T call expandFromPip here - it hides PiP before Chat.js mounts
      // Just navigate with the flag and let Chat.js handle the expansion
      navigate("/chat", {
        state: {
          chat_id: unifiedCallState.chat_id,
          selectedUser: unifiedCallState.user,
          appointment: unifiedCallState.appointment,
          expandingFromPip: true,
        },
      });
    }
  };

  const handleEndCallFromFloating = async () => {
    try {
      if (endCallFunctionRef.current) {
        const callType = callMetadata.callType;

        if (callType === "video") {
          await endCallFunctionRef.current.endVideoCall();
        } else if (callType === "audio") {
          await endCallFunctionRef.current.endAudioCall();
        }

        // Don't call setIsCallMinimized(false) here - it causes expand flash
        // PiP will auto-hide when isInCall becomes false
      }
    } catch (err) {
      console.error("Error ending call from PiP:", err);
    }
  };

  const isUserAgentReactSnap =
    typeof window === "undefined" ||
    navigator.userAgent.includes("ReactSnap") ||
    !window.navigator;

  useEffect(() => {
    trackEvent("app_open", {
      user_name: userDetails?.first_name ? `${userDetails.first_name} ${userDetails.last_name || ""}`.trim() : "",
      user_role: userDetails?.role,
    });
    return () => {
      try {
        pauseAudio();
      } catch (err) {
        console.error(err);
      }
    };
  }, []);

  // Global protection for active calls - works across all screens
  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (isInCall) {
        e.preventDefault();
        e.returnValue =
          "You are currently in a call. Are you sure you want to leave?";
        return e.returnValue;
      }
    };

    const handlePopState = (e) => {
      if (isInCall) {
        // If call is in full screen, automatically minimize to PiP
        if (!isCallMinimized) {
          debugLog("App_NavigationMinimize_Started", {
            currentPath: window.location.pathname,
            isInCall,
            isCallMinimized,
            unifiedCallState: {
              status: unifiedCallState.status,
              type: unifiedCallState.type,
              role: unifiedCallState.role,
              chat_id: unifiedCallState.chat_id,
            },
            channelParameters: {
              hasLocalVideo: !!channelParameters.localVideoTrack,
              hasRemoteVideo: !!channelParameters.remoteVideoTrack,
              hasLocalAudio: !!channelParameters.localAudioTrack,
              hasRemoteAudio: !!channelParameters.remoteAudioTrack,
            },
          });

          // Update callMetadata with current state before navigation
          // Use unifiedCallState.user as primary source (more reliable than selectedUser)
          const userName = unifiedCallState.user?.first_name
            ? `${unifiedCallState.user.first_name} ${
                unifiedCallState.user.last_name || ""
              }`.trim()
            : selectedUser?.first_name
            ? `${selectedUser.first_name} ${
                selectedUser.last_name || ""
              }`.trim()
            : callMetadata?.userName || "";

          // Determine sendingCall/receivingCall from unifiedCallState.role
          const isCaller = unifiedCallState.role === "caller";
          const isCallee = unifiedCallState.role === "callee";

          setCallMetadata((prev) => ({
            ...prev,
            userName: userName || prev.userName,
            chat_id: unifiedCallState.chat_id || prev.chat_id,
            // Save call states if not already saved
            callType: unifiedCallState.type || prev.callType,
            sendingCall: isCaller !== undefined ? isCaller : prev.sendingCall,
            receivingCall:
              isCallee !== undefined ? isCallee : prev.receivingCall,
            // Preserve tracks from channelParameters
            localVideoTrack:
              channelParameters.localVideoTrack || prev.localVideoTrack,
            remoteVideoTrack:
              channelParameters.remoteVideoTrack || prev.remoteVideoTrack,
            localAudioTrack:
              channelParameters.localAudioTrack || prev.localAudioTrack,
            remoteAudioTrack:
              channelParameters.remoteAudioTrack || prev.remoteAudioTrack,
          }));

          debugLog("App_NavigationMinimize_CallMetadataSaved", {
            userName,
            isCaller,
            isCallee,
            callType: unifiedCallState.type,
            savedStates: {
              sendingCall: isCaller,
              receivingCall: isCallee,
            },
          });

          // Set minimize flag
          setIsCallMinimized(true);
          updateCallState({ isMinimized: true });

          debugLog("App_NavigationMinimize_Complete", {
            isCallMinimized: true,
          });

          // Allow navigation to continue
        } else {
          debugLog("App_NavigationWhileMinimized", {
            currentPath: window.location.pathname,
            isInCall,
            isCallMinimized: true,
          });
        }
        // If already in PiP, allow navigation without confirmation
        // User can continue the call in PiP while navigating
      }
    };

    // Add listeners
    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("popstate", handlePopState);

    // Push initial state to enable popstate handling
    if (isInCall) {
      window.history.pushState(null, "", window.location.href);
    }

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      window.removeEventListener("popstate", handlePopState);
    };
  }, [isInCall, isCallMinimized, callMetadata.callType]);

  useEffect(() => {
    try {
      if (!app_js_intialLoad?.current && userDetails?._id) {
        const Socket = io(ConstConfig.SOCKET_CONNECTION_URL, {
          transports: ["websocket"],
          query: { user_id: userDetails._id },
        });
        setSocket(Socket);
        // getAudioPermission();
        get_agora_token(`Channel ${new Date().getTime()}`);

        Socket.on("connect", (data) => {
          // Remove existing event listeners to prevent duplicates
          Socket.off("refresh_appointment");
          Socket.off("message");
          Socket.off("new_message");
          // Listen new listeners again
          Socket.on("refresh_appointment", (data) => {
            setRefreshAppointmentType((prevState) => ({
              type: data.type,
              version: prevState.version + 1,
            }));
          });
          Socket.on("message", async (data) => {
            if (isToken) {
              // ============================================================================
              // 🆕 MULTI-DEVICE FIX: Handle "call_answered_elsewhere" BEFORE condition check
              // This event needs to be processed even if not directly addressed to this user
              // ============================================================================
              if (
                data?.message_event_type == "call_answered_elsewhere" ||
                data?.message_event_type == "call_connected_elsewhere"
              ) {
                pauseAudio();
                toast.dismiss();
                // Still pass to setAgoraMessage for Chat.js to handle
                setAgoraMessage(data);
                return; // Exit early
              }
              // ============================================================================

              if (data?.to == userDetails?._id) {
                if (
                  data?.type == "message" &&
                  data?.from != selectedChat_user?.current
                ) {
                  toast(
                    `New message from ${data?.from_user_first_name || "User"} ${
                      data?.from_user_last_name || ""
                    } : ${data?.message || ""}`,
                    {
                      autoClose: 4000,
                      position: "top-right",
                      hideProgressBar: true,
                      type: "success",
                      icon: false,
                      onClick: () => {
                        navigate("/chat", {
                          state: {
                            chat_id: data?.from,
                            data,
                          },
                        });
                      },
                    }
                  );
                } else if (
                  data?.type == "image" &&
                  data?.from != selectedChat_user?.current
                ) {
                  toast(
                    `New image from ${data?.from_user_first_name || "User"} ${
                      data?.from_user_last_name || ""
                    } : \u{1F4F7}`,
                    {
                      autoClose: 4000,
                      position: "top-right",
                      hideProgressBar: true,
                      type: "success",
                      icon: false,
                      onClick: () => {
                        navigate("/chat", {
                          state: {
                            chat_id: data?.from,
                            data,
                          },
                        });
                      },
                    }
                  );
                } else if (
                  data?.type == "video_call" &&
                  data?.call_status == "calling"
                ) {
                  setRunningCallId(data?.message_id);
                  // Store global reference so we can always stop it
                  window.activeRingtone = receive_call_audio;
                  receive_call_audio.play().catch((error) => {
                    console.error("Audio play failed:", error);
                  });
                  toast.dismiss();
                  toast.info(
                    <div className="call-notification">
                      <span>
                        {<VideoCallOutlinedIcon color="white" />}{" "}
                        {`You have a new
                        call from ${data?.call_from || "User"}`}
                      </span>
                      <div className="button-container">
                        <button
                          onClick={() => {
                            toast.dismiss();
                            pauseAudio();
                            setAcceptThroughPopup(true);
                            setRunningCallId(data?.message_id);
                            navigate("/chat", {
                              state: {
                                chat_id: data?.from,
                                data,
                              },
                            });
                          }}
                          className="accept-button"
                        >
                          <i className="fas fa-phone-volume"></i> Accept Call
                        </button>
                        <button
                          onClick={() => {
                            toast.dismiss();
                            pauseAudio();
                            Socket.emit("message", {
                              end_by: userDetails?._id,
                              message_event_type: "end_video_call",
                              type: "video_call",
                              call_status: "rejected",
                              message_id: data?.message_id,
                            });
                          }}
                          className="reject-button"
                        >
                          <i className="fas fa-phone-slash"></i> Reject Call
                        </button>
                      </div>
                    </div>,
                    {
                      autoClose: 3600000,
                      icon: false,
                      type: "success",
                      closeOnClick: false,
                      closeButton: false,
                    }
                  );
                } else if (
                  data?.type == "voice_call" &&
                  data?.call_status == "calling"
                ) {
                  setRunningCallId(data?.message_id);
                  // Store global reference so we can always stop it
                  window.activeRingtone = receive_call_audio;
                  receive_call_audio.play().catch((error) => {
                    console.error("Audio play failed:", error);
                  });
                  toast.dismiss();
                  toast.info(
                    <div className="call-notification">
                      <span>
                        {<CallIcon color="white" />}{" "}
                        {`You have a new
                        call from ${data?.call_from || "User"}`}
                      </span>

                      <div className="button-container">
                        <button
                          onClick={() => {
                            pauseAudio();
                            toast.dismiss();
                            setAcceptThroughPopup(true);
                            setRunningCallId(data?.message_id);
                            navigate("/chat", {
                              state: {
                                chat_id: data?.from,
                                data,
                              },
                            });
                          }}
                          className="accept-button"
                        >
                          <i className="fas fa-phone-volume"></i> Accept Call
                        </button>
                        <button
                          onClick={() => {
                            pauseAudio();
                            toast.dismiss();

                            Socket.emit("message", {
                              end_by: userDetails?._id,
                              message_event_type: "end_voice_call",
                              type: "voice_call",
                              call_status: "rejected",
                              message_id: data?.message_id,
                            });
                          }}
                          className="reject-button"
                        >
                          <i className="fas fa-phone-slash"></i> Reject Call
                        </button>
                      </div>
                    </div>,
                    {
                      autoClose: 3600000,
                      icon: false,
                      type: "success",
                      closeOnClick: false,
                      closeButton: false,
                    }
                  );
                } else if (
                  (data?.type == "video_call" || data?.type == "voice_call") &&
                  (data?.message_event_type == "end_voice_call" ||
                    data?.message_event_type == "end_video_call")
                ) {
                  pauseAudio();
                  toast.dismiss();
                }
              } else {
                if (
                  (data?.type == "video_call" || data?.type == "voice_call") &&
                  (data?.message_event_type == "accepted_voice_call" ||
                    data?.message_event_type == "accepted_video_call")
                ) {
                  pauseAudio();
                  toast.dismiss();
                }
              }

              // DEBUG: Log ALL socket messages received in App.js

              setAgoraMessage(data);
            }
          });
          Socket.on("new_message", (data) => {
            if (isToken) {
              setAgoraNewMessage(data);
            }
          });
          Socket.on("disconnect", () => {});
        });
        app_js_intialLoad.current = true;
      }
    } catch (err) {
      console.error(err);
    }
  }, [user]);

  function SessionOutModal(props) {
    return (
      <Modal
        {...props}
        size="sm"
        className="modalSuccess"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <h2>Oops...</h2>
          <h4>Session Out</h4>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => {
              setSessionModalShow(false);
            }}
          >
            OK
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  function handleProceedLicense() {
    navigate("/therapisteditProfile");
    setShowOldLicenseModal(false);
  }

  function handleCancelLicense() {
    setShowOldLicenseModal(false);
  }

  function OldLicenseModal(props) {
    return (
      <Modal {...props} size="md" centered>
        <Modal.Header closeButton>
          <Modal.Title>Action Required: Licenses Verification</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            We’ve received your license, but verification is still pending.
            Please visit your Profile Settings to complete the verification
            process.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCancelLicense}>
            Cancel
          </Button>
          <Button variant="primary" onClick={handleProceedLicense}>
            Proceed
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }

  // Show loader while checking authentication
  if (authLoading) {
    return <Loader />;
  }

  return (
    <ReactIdleProvider isUserLoggedIn={isDataFound}>
      {showTimezoneChangeAlert && (
        <CustomAlertModal
          status={showTimezoneChangeAlert}
          title="Your timezone settings have been updated. Please adjust your availability to ensure a seamless experience and continued optimal service."
          onClose={() => {
            setShowTimezoneChangeAlert(false);
            navigate("/therapisteditProfile");
          }}
        />
      )}
      <OldLicenseModal
        show={showOldLicenseModal}
        onHide={() => setShowOldLicenseModal(false)}
      />
      <SessionOutModal
        show={sessionModal}
        onHide={() => setSessionModalShow(false)}
      />
      {!isUserAgentReactSnap ? (
        google_client_id && (
          <GoogleOAuthProvider clientId={google_client_id}>
            <>
              <ToastContainer pauseOnHover autoClose={3000} theme="colored" />
              {loading && <Loader />}

              <ScrollToTopMain />
              <MayRenderNav>
                <Header />
              </MayRenderNav>
              <Routes>
                <Route exact path={"/"} element={<Home />} />

                <Route
                  path="/patientregisteration"
                  element={
                    isDataFound ? (
                      <Navigate to={"/dashboard"} />
                    ) : (
                      <Patientregisteration />
                    )
                  }
                />
                <Route
                  path="/login"
                  element={
                    isDataFound ? <Navigate to={"/dashboard"} /> : <Login />
                  }
                />
                <Route
                  path="/otp"
                  element={
                    isDataFound ? <Navigate to={"/dashboard"} /> : <Otp />
                  }
                />
                <Route
                  path="/therapistregisteration"
                  element={
                    isDataFound ? (
                      <Navigate to={"/dashboard"} />
                    ) : (
                      <TherapistRegisteration />
                    )
                  }
                />
                <Route
                  path="/therapistcompleteprofile"
                  element={
                    isDataFound ? (
                      <Navigate to={"/dashboard"} />
                    ) : (
                      <TherapistCompleteProfile />
                    )
                  }
                />
                <Route path="/about" element={<About />} />
                <Route path="/findtherapist" element={<FindTherapist />} />
                <Route path="/contactus" element={<ContactUs />} />
                <Route
                  path="/therapistdetailspage/:id"
                  element={<TherapistDetailsPage />}
                />
                <Route
                  path="/bookanappointment"
                  element={
                    isDataFound ? (
                      <BookAnAppointment />
                    ) : (
                      <Navigate to={ROOT_PATH} />
                    )
                  }
                />
                <Route
                  path="/enterpaymentdetails"
                  element={
                    isDataFound ? (
                      <EnterPaymentDetails />
                    ) : (
                      <Navigate to={ROOT_PATH} />
                    )
                  }
                />

                <Route
                  path="/patientsidebar"
                  element={
                    isDataFound ? (
                      <PatientSidebar />
                    ) : (
                      <Navigate to={ROOT_PATH} />
                    )
                  }
                />

                <Route
                  path="/patientfavourite"
                  element={
                    isDataFound ? (
                      <PatientFavourite />
                    ) : (
                      <Navigate to={ROOT_PATH} />
                    )
                  }
                />
                <Route
                  path="/paymentsettings"
                  element={
                    isDataFound ? (
                      <PaymentSettings />
                    ) : (
                      <Navigate to={ROOT_PATH} />
                    )
                  }
                />
                <Route
                  path="/patienteditProfile"
                  element={
                    isDataFound ? (
                      <PatientEditProfile />
                    ) : (
                      <Navigate to={ROOT_PATH} />
                    )
                  }
                />

                <Route
                  path="/dashboard"
                  element={
                    isDataFound ? <Dashboard /> : <Navigate to={ROOT_PATH} />
                  }
                />
                <Route
                  path="/therapistsidebar"
                  element={
                    isDataFound ? (
                      <TherapistSidebar />
                    ) : (
                      <Navigate to={ROOT_PATH} />
                    )
                  }
                />
                <Route
                  path="/chat"
                  element={isDataFound ? <Chat /> : <Navigate to={ROOT_PATH} />}
                />
                <Route
                  path="/notificationsettings"
                  element={
                    isDataFound ? (
                      <NotificationSettings />
                    ) : (
                      <Navigate to={ROOT_PATH} />
                    )
                  }
                />
                <Route
                  path="/therapisteditprofile"
                  element={
                    isDataFound ? (
                      <TherapistEditProfile />
                    ) : (
                      <Navigate to={ROOT_PATH} />
                    )
                  }
                />
                <Route
                  path="/therapistearnings"
                  element={
                    isDataFound ? (
                      <TherapistEarnings />
                    ) : (
                      <Navigate to={ROOT_PATH} />
                    )
                  }
                />
                <Route
                  path="/therapistbankdetails"
                  element={
                    isDataFound ? (
                      <TherapistBankDetails />
                    ) : (
                      <Navigate to={ROOT_PATH} />
                    )
                  }
                />
                <Route
                  path="/therapistbankconnected"
                  element={
                    isDataFound ? (
                      <TherapistBankConnected />
                    ) : (
                      <Navigate to={ROOT_PATH} />
                    )
                  }
                />
                <Route path="/helpandsupport" element={<HelpAndSupport />} />
                <Route path="/privacypolicy" element={<PrivacyPolicy />} />
                <Route path="/hipaa" element={<Hipaa />} />
                <Route path="/q&a" element={<QandA />} />
                <Route path="/termsofservice" element={<TermsOfService />} />
                <Route
                  path="/DeleteAccountInstructions"
                  element={<DeleteAccountInstructions />}
                />
                <Route
                  path="/ratingreview/:id"
                  element={
                    isDataFound ? <RatingreView /> : <Navigate to={ROOT_PATH} />
                  }
                />
                <Route
                  path="/appointmentdetail"
                  element={
                    isDataFound ? (
                      <AppointmentDetail />
                    ) : (
                      <Navigate to={ROOT_PATH} />
                    )
                  }
                />
                <Route
                  path="/patientappointmentdetail/:id"
                  element={
                    isDataFound ? (
                      <PatientAppointmentDetail />
                    ) : (
                      <Navigate to={ROOT_PATH} />
                    )
                  }
                />
                <Route
                  path="/therapistappointmentdetail"
                  element={
                    isDataFound ? (
                      <TherapistAppointmentDetail />
                    ) : (
                      <Navigate to={ROOT_PATH} />
                    )
                  }
                />

                <Route
                  path="/requestAppointmentDetails"
                  element={
                    isDataFound ? (
                      <RequestAppointmentDetails />
                    ) : (
                      <Navigate to={ROOT_PATH} />
                    )
                  }
                />
                <Route path="/therapist" element={<Therapist />} />
                <Route path="/patient" element={<Therapist />} />
                <Route path="/team" element={<Team />} />
                <Route path="/news" element={<News />} />
                <Route path="/blogpost/:news_id" element={<BlogPost />} />
              </Routes>
              <MayRenderNav>
                <Footer />
              </MayRenderNav>
              <ScrollToTop />
              {!isInCall && <ChatBot />}

              {/* Picture-in-Picture Window - Persists across routes */}
              {isCallMinimized &&
                isInCall &&
                (() => {
                  return (
                    <FloatingCallWindow
                      key={`pip-${!!callMetadata.remoteVideoTrack}`}
                      isVideoCall={callMetadata.callType === "video"}
                      isAudioCall={callMetadata.callType === "audio"}
                      showMessage={callMetadata.showMessage || "In call..."}
                      mute_audio={callMetadata.mute_audio}
                      hide_video={callMetadata.hide_video}
                      onEndCall={handleEndCallFromFloating}
                      onExpand={handleExpandFromFloating}
                      selectedUser={selectedUser}
                      userName={callMetadata.userName} // Pass saved name for after re-login
                      localVideoTrack={callMetadata.localVideoTrack}
                      remoteVideoTrack={callMetadata.remoteVideoTrack}
                      localAudioTrack={callMetadata.localAudioTrack}
                      remoteAudioTrack={callMetadata.remoteAudioTrack}
                    />
                  );
                })()}
            </>
          </GoogleOAuthProvider>
        )
      ) : (
        <>
          <ToastContainer pauseOnHover autoClose={3000} theme="colored" />
          {loading && <Loader />}

          <ScrollToTopMain />
          <MayRenderNav>
            <Header />
          </MayRenderNav>
          <Routes>
            <Route exact path={"/"} element={<Home />} />

            <Route
              path="/patientregisteration"
              element={
                isDataFound ? (
                  <Navigate to={"/dashboard"} />
                ) : (
                  <Patientregisteration />
                )
              }
            />
            <Route
              path="/login"
              element={isDataFound ? <Navigate to={"/dashboard"} /> : <Login />}
            />
            <Route
              path="/otp"
              element={isDataFound ? <Navigate to={"/dashboard"} /> : <Otp />}
            />
            <Route
              path="/therapistregisteration"
              element={
                isDataFound ? (
                  <Navigate to={"/dashboard"} />
                ) : (
                  <TherapistRegisteration />
                )
              }
            />
            <Route
              path="/therapistcompleteprofile"
              element={
                isDataFound ? (
                  <Navigate to={"/dashboard"} />
                ) : (
                  <TherapistCompleteProfile />
                )
              }
            />
            <Route path="/about" element={<About />} />
            <Route path="/findtherapist" element={<FindTherapist />} />
            <Route path="/contactus" element={<ContactUs />} />
            <Route
              path="/therapistdetailspage/:id"
              element={<TherapistDetailsPage />}
            />
            <Route
              path="/bookanappointment"
              element={
                isDataFound ? (
                  <BookAnAppointment />
                ) : (
                  <Navigate to={ROOT_PATH} />
                )
              }
            />
            <Route
              path="/enterpaymentdetails"
              element={
                isDataFound ? (
                  <EnterPaymentDetails />
                ) : (
                  <Navigate to={ROOT_PATH} />
                )
              }
            />

            <Route
              path="/patientsidebar"
              element={
                isDataFound ? <PatientSidebar /> : <Navigate to={ROOT_PATH} />
              }
            />

            <Route
              path="/patientfavourite"
              element={
                isDataFound ? <PatientFavourite /> : <Navigate to={ROOT_PATH} />
              }
            />
            <Route
              path="/paymentsettings"
              element={
                isDataFound ? <PaymentSettings /> : <Navigate to={ROOT_PATH} />
              }
            />
            <Route
              path="/patienteditProfile"
              element={
                isDataFound ? (
                  <PatientEditProfile />
                ) : (
                  <Navigate to={ROOT_PATH} />
                )
              }
            />

            <Route
              path="/dashboard"
              element={
                isDataFound ? <Dashboard /> : <Navigate to={ROOT_PATH} />
              }
            />
            <Route
              path="/therapistsidebar"
              element={
                isDataFound ? <TherapistSidebar /> : <Navigate to={ROOT_PATH} />
              }
            />
            <Route
              path="/chat"
              element={isDataFound ? <Chat /> : <Navigate to={ROOT_PATH} />}
            />
            <Route
              path="/notificationsettings"
              element={
                isDataFound ? (
                  <NotificationSettings />
                ) : (
                  <Navigate to={ROOT_PATH} />
                )
              }
            />
            <Route
              path="/therapisteditprofile"
              element={
                isDataFound ? (
                  <TherapistEditProfile />
                ) : (
                  <Navigate to={ROOT_PATH} />
                )
              }
            />
            <Route
              path="/therapistearnings"
              element={
                isDataFound ? (
                  <TherapistEarnings />
                ) : (
                  <Navigate to={ROOT_PATH} />
                )
              }
            />
            <Route
              path="/therapistbankdetails"
              element={
                isDataFound ? (
                  <TherapistBankDetails />
                ) : (
                  <Navigate to={ROOT_PATH} />
                )
              }
            />
            <Route
              path="/therapistbankconnected"
              element={
                isDataFound ? (
                  <TherapistBankConnected />
                ) : (
                  <Navigate to={ROOT_PATH} />
                )
              }
            />
            <Route path="/helpandsupport" element={<HelpAndSupport />} />
            <Route path="/privacypolicy" element={<PrivacyPolicy />} />
            <Route path="/hipaa" element={<Hipaa />} />
            <Route path="/q&a" element={<QandA />} />
            <Route path="/termsofservice" element={<TermsOfService />} />
            <Route
              path="/DeleteAccountInstructions"
              element={<DeleteAccountInstructions />}
            />
            <Route
              path="/ratingreview/:id"
              element={
                isDataFound ? <RatingreView /> : <Navigate to={ROOT_PATH} />
              }
            />
            <Route
              path="/appointmentdetail"
              element={
                isDataFound ? (
                  <AppointmentDetail />
                ) : (
                  <Navigate to={ROOT_PATH} />
                )
              }
            />
            <Route
              path="/patientappointmentdetail/:id"
              element={
                isDataFound ? (
                  <PatientAppointmentDetail />
                ) : (
                  <Navigate to={ROOT_PATH} />
                )
              }
            />
            <Route
              path="/therapistappointmentdetail"
              element={
                isDataFound ? (
                  <TherapistAppointmentDetail />
                ) : (
                  <Navigate to={ROOT_PATH} />
                )
              }
            />

            <Route
              path="/requestAppointmentDetails"
              element={
                isDataFound ? (
                  <RequestAppointmentDetails />
                ) : (
                  <Navigate to={ROOT_PATH} />
                )
              }
            />
            <Route path="/therapist" element={<Therapist />} />
            <Route path="/patient" element={<Therapist />} />
            <Route path="/team" element={<Team />} />
            <Route path="/news" element={<News />} />
            <Route path="/blogpost/:news_id" element={<BlogPost />} />
          </Routes>
          <MayRenderNav>
            <Footer />
          </MayRenderNav>
          <ScrollToTop />
          <ChatBot />

          {/* Picture-in-Picture Window - Persists across routes */}
          {(isCallMinimized || unifiedCallState.isMinimized) &&
            (isInCall || unifiedCallState.status !== "idle") &&
            (() => {
              // DEBUG: Log PiP call type determination
              const isVideoPip =
                unifiedCallState.type === "video" ||
                callMetadata.callType === "video";
              const isAudioPip =
                unifiedCallState.type === "audio" ||
                callMetadata.callType === "audio";

              return (
                <FloatingCallWindow
                  key={`pip-${
                    !!unifiedCallState.tracks.remoteVideo ||
                    !!callMetadata.remoteVideoTrack
                  }`}
                  isVideoCall={isVideoPip}
                  isAudioCall={isAudioPip}
                  showMessage={
                    unifiedCallState.showMessage ||
                    callMetadata.showMessage ||
                    "In call..."
                  }
                  mute_audio={
                    unifiedCallState.isMuted || callMetadata.mute_audio
                  }
                  hide_video={
                    unifiedCallState.isVideoHidden || callMetadata.hide_video
                  }
                  onEndCall={handleEndCallFromFloating}
                  onExpand={handleExpandFromFloating}
                  selectedUser={
                    unifiedCallState.user._id
                      ? unifiedCallState.user
                      : selectedUser
                  }
                  userName={
                    unifiedCallState.user.first_name
                      ? `${unifiedCallState.user.first_name} ${unifiedCallState.user.last_name}`.trim()
                      : callMetadata.userName || "In call..."
                  }
                  localVideoTrack={
                    unifiedCallState.tracks.localVideo ||
                    callMetadata.localVideoTrack
                  }
                  remoteVideoTrack={
                    unifiedCallState.tracks.remoteVideo ||
                    callMetadata.remoteVideoTrack
                  }
                  localAudioTrack={
                    unifiedCallState.tracks.localAudio ||
                    callMetadata.localAudioTrack
                  }
                  remoteAudioTrack={
                    unifiedCallState.tracks.remoteAudio ||
                    callMetadata.remoteAudioTrack
                  }
                />
              );
            })()}
        </>
      )}
    </ReactIdleProvider>
  );
}

export default App;
